<template>
    <div class="text-block block-card card-border big-card-block">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/airplane.png" alt="">
                        </div>

                        <h4>Flight</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <label >Status</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.status"-->
<!--                            :error="!data.status"-->
<!--                            :error-messages="!data.status? 'Status is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.status" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Status is Required']">

                    </vTextareaAutocomplete>
                    <label >Date</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.date"-->
<!--                            :error="!data.date"-->
<!--                            :error-messages="!data.date? 'Date is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.date" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Date is Required']">

                    </vTextareaAutocomplete>
                    <v-layout>
                        <v-flex sm4 class="pa-0">
                            <label >Flight</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.flight"-->
<!--                                    :error="!data.flight"-->
<!--                                    :error-messages="!data.flight? 'flight is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.flight" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'flight is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex sm4>
                            <label >Departs</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.departs"-->
<!--                                    :error="!data.departs"-->
<!--                                    :error-messages="!data.departs? 'Departs is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.departs" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Departs is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex sm4 class="pa-0">
                            <label >Arrives</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.arrives"-->
<!--                                    :error="!data.arrives"-->
<!--                                    :error-messages="!data.arrives? 'Arrives is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.arrives" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Arrives is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-4 align-center">
                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.travel.originName"-->
<!--                                    :error="!data.travel.originName"-->
<!--                                    placeholder="Origin Name"-->

<!--                                    :error-messages="!data.travel.originName? 'Origin Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.travel.originName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Origin Name is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.travel.originAcronym"-->
<!--                                    :error="!data.travel.originAcronym"-->
<!--                                    placeholder="Origin Acc"-->
<!--                                    :error-messages="!data.travel.originAcronym? 'Origin is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.travel.originAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Acronym name is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                        <v-flex sm4 class="text-sm-center">
                            <v-icon color="primary" large>airplanemode_active</v-icon>
                        </v-flex>

                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.travel.destName"-->
<!--                                    :error="!data.travel.destName"-->
<!--                                    placeholder="Destination"-->
<!--                                    :error-messages="!data.travel.destName? 'Destination Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.travel.destName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Destination name is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.travel.destAcronym"-->
<!--                                    :error="!data.travel.destAcronym"-->
<!--                                    placeholder="destAcronym"-->
<!--                                    :error-messages="!data.travel.destAcronym? 'destAcronym Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.travel.destAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Destination Acronym name is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-audio",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>